import { render, staticRenderFns } from "./CommonFormWithSystemCalendarEditor.vue?vue&type=template&id=497d135e&lang=pug&"
import script from "./CommonFormWithSystemCalendarEditor.vue?vue&type=script&lang=ts&"
export * from "./CommonFormWithSystemCalendarEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CommonFormWithSystemCalendarEditor.vue?vue&type=style&index=0&id=497d135e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports